import ModuleContent from 'features/shared/layout/content/ModuleContent';
import Header from 'features/shared/layout/header/Header';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import ExportsSections from './sections/ExportsSections';
import ExportDetailPage from './pages/ExportDetailPage';

type Props = {}

const Exports = (props: Props) => {
  const { t } = useTranslation("shared\\moduleNames");
  const match = useRouteMatch();

  return (
    <Switch>
      <Route path={`${match.path}/:exportDefinitionId`} component={ExportDetailPage}/>
      <Route path={match.path}>
        <Header title={t("exports.title")} includeBreadcrumbs />
        <ModuleContent>
          <ExportsSections />
        </ModuleContent>
      </Route>
    </Switch>
  );
}

export default Exports;;